import React, { useEffect } from 'react';
import IvoriMethodOxbridgePage from '../../features/method/IvoriMethodOxbridgePage';

export default function IvoriMethodOxbridgeRoute() {
  useEffect(() => {
    document.title = "The IVORI Method — Oxbridge Interview Pedagogy | Pathbuddy";
    window.scrollTo(0, 0);
  }, []);

  return <IvoriMethodOxbridgePage />;
}
